export default class TopNavigationMenuItem {
    public id: number;
    public linkText: string;
    public linkUrl: string;
    public subMenuItems: TopNavigationMenuItem[];
    public isExpanded: boolean;
    public additionalCssClass: string;
    public urlTarget: string;
  
    constructor() {
      this.id = -1;
      this.linkText = "";
      this.linkUrl = "";
      this.subMenuItems = [];
      this.isExpanded = false;
      this.additionalCssClass = "";
      this.urlTarget = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/topNavigationMenuEntity.ts